<template>
  <section v-on:click="sectionClicked">
    <div class="loadingFull" v-if="loading"></div>
    <section>
      <div class="page-loading" :class="{closed: !loading}"></div>
      <div class="welcome-cnt" :class="{open: welcome.open, intro: welcome.intro, video: welcome.video,
        introFinished: welcome.introFinished, openFinished: welcome.openFinished}">
        <Header ref="header" :class="{scrolled: scrolled, intro: welcome.intro, hasBg: fadeWhite > 0.6}"
          v-on:toggleAudio="toggleAudio" :audioMuted="isMuted"/>
        <div class="welcome">
          <div class="welcome-bg" v-if="pd.home && pd.home.items.length > 0"
            :style="{'background-image': `url(${pd.home.items[0].media[lang].imageLg})`}"></div>
          <div class="welcome-bg noImg"></div>
          <div class="welcome-overlay" v-if="pd.home && pd.home.items.length > 0
            && pd.home.items[0].imageOverlay" :style="{opacity: pd.home.items[0].overlayOpacity,
            'background-color': pd.home.items[0].overlayColor}"></div>
          <div class="welcome-video" v-if="pd.homeVideo && pd.homeVideo.items.length > 0">
            <video id="welcomeVideo" ref="video" playsinline>
              <source :src="pd.homeVideo.items[0].media[lang].vid1080p" type="video/mp4"
                v-if="pd.homeVideo.items[0].media[lang].vid1080p">
              <source :src="pd.homeVideo.items[0].media[lang].vid720p" type="video/mp4"
                v-if="pd.homeVideo.items[0].media[lang].vid720p">
              <source :src="pd.homeVideo.items[0].media[lang].vid480p" type="video/mp4"
                v-if="pd.homeVideo.items[0].media[lang].vid480p">
              <source :src="pd.homeVideo.items[0].media[lang].vid360p" type="video/mp4"
                v-if="pd.homeVideo.items[0].media[lang].vid360p">
              Your browser does not support HTML5 video.
            </video>
          </div>
          <div class="info-cnt">
            <div>
              <button class="btn primary" v-on:click="openIntro" ref="enterSite"
                v-if="pd.home && pd.home.items.length > 0">
                <span>{{pd.home.items[0].buttonLabel[lang]}}</span>
              </button>
              <a :href="`/${langCode}/mau-nonton-/mau-nonton-submenu/-before-you-eat-director-s-cut`"
                class="btn primary">
                <span v-if="lang === 'en'">Watch Film</span>
                <span v-else>Tonton Film</span>
              </a>
            </div>
            <div class="org-logos" v-if="pd.orgLogo && pd.orgLogo.items.length > 0">
              <div v-for="(orgLogo, i) in pd.orgLogo.items"
                :key="`orlg${i}`" class="logo-item">
                <h4 v-if="orgLogo.title[lang]">{{orgLogo.title[lang]}}</h4>
                <img :src="orgLogo.media[lang].imageSm">
              </div>
            </div>
          </div>
        </div>
        <div class="logo" v-on:click="logoClicked"
          v-if="pd.homeLogo && pd.homeLogo.items.length > 0"
          :style="{'background-image': `url(${pd.homeLogo.items[0].media[lang].imageLg})`}"></div>
        <div class="welcome-overlay-2"></div>
        <div class="welcome-overlay-3" :style="{opacity: fadeBlack}"></div>
        <div class="welcome-overlay-3 overlay-3a" :style="{opacity: fadeWhite}"></div>
        <div class="welcome-action" :class="{hidden: fadeBlack >= 0.12}">
          <div class="trailer-cnt" v-if="pd.trailer && pd.trailer.items.length > 0"
            :class="`trailer-item-${pd.trailer.items.length}`">
            <div class="trailer-item" v-on:click="openTrailer(trailer)"
              v-for="(trailer, i) in pd.trailer.items" :key="`trl${i}`">
              <span>{{trailer.buttonLabel[lang]}}</span>
            </div>
          </div>
          <div class="scroll-info">
            <template v-if="lang === 'en'">
              Scroll to find out more
            </template>
            <template v-if="lang === 'id'">
              Scroll untuk informasi lebih lanjut
            </template>
          </div>
        </div>
        <template v-if="welcome.intro">
          <Page :page="page" :breadcrumb="false"/>
        </template>
      </div>
    </section>

    <Footer v-if="welcome.intro"/>
    <WelcomeDialog ref="welcomeDialog"/>
    <VideoDialogLocal ref="videoDialogLocal"/>
    <VideoDialogSinopsis ref="videoDialogSinopsis"/>
    <VideoDialogComingSoon ref="videoDialogComingSoon"/>
    <ImageViewer ref="imageViewer"/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import Page from '@/components/Page.vue';
import Footer from '@/components/Footer.vue';
import WelcomeDialog from '@/components/WelcomeDialog.vue';
import VideoDialogLocal from '@/components/VideoDialogLocal.vue';
import VideoDialogSinopsis from '@/components/VideoDialogSinopsis.vue';
import VideoDialogComingSoon from '@/components/VideoDialogComingSoon.vue';
import ImageViewer from '@/components/ImageViewer.vue';

export default {
  name: 'home',
  components: {
    Header,
    Page,
    Footer,
    WelcomeDialog,
    VideoDialogLocal,
    VideoDialogSinopsis,
    VideoDialogComingSoon,
    ImageViewer,
  },
  data() {
    return {
      loading: true,
      scrolled: false,
      page: null,
      welcome: {
        open: false,
        intro: false,
        introFinished: false,
        openFinished: false,
        video: false,
      },
      fadeBlack: 0,
      fadeWhite: 0,
      gOffset: 0,
      menuOpen: false,

      lang: 'id',
      langCode: 'id-id',

      /**
       * Page from cms
       *
       */
      pd: {
        home: null,
        homeLogo: null,
        orgLogo: null,
        homeVideo: null,
        trailer: null,
      },

      isMuted: false,
      gallery: [
        { imageLg: 'https://bye-api.dddtl.net/media/12foto/1.jpg' },
        { imageLg: 'https://bye-api.dddtl.net/media/12foto/2.jpg' },
        { imageLg: 'https://bye-api.dddtl.net/media/12foto/3.jpg' },
        { imageLg: 'https://bye-api.dddtl.net/media/12foto/4.jpg' },
        { imageLg: 'https://bye-api.dddtl.net/media/12foto/5.jpg' },
        { imageLg: 'https://bye-api.dddtl.net/media/12foto/6.jpg' },
        { imageLg: 'https://bye-api.dddtl.net/media/12foto/7.jpg' },
        { imageLg: 'https://bye-api.dddtl.net/media/12foto/8.jpg' },
        { imageLg: 'https://bye-api.dddtl.net/media/12foto/9.jpg' },
        { imageLg: 'https://bye-api.dddtl.net/media/12foto/10.jpg' },
        { imageLg: 'https://bye-api.dddtl.net/media/12foto/11.jpg' },
        { imageLg: 'https://bye-api.dddtl.net/media/12foto/12.jpg' },
        { imageLg: 'https://bye-api.dddtl.net/media/12foto/13.jpg' },
        { imageLg: 'https://bye-api.dddtl.net/media/12foto/14.jpg' },
        { imageLg: 'https://bye-api.dddtl.net/media/12foto/15.jpg' },
        { imageLg: 'https://bye-api.dddtl.net/media/12foto/16.jpg' },
        { imageLg: 'https://bye-api.dddtl.net/media/12foto/17.jpg' },
        { imageLg: 'https://bye-api.dddtl.net/media/12foto/18.jpg' },
      ],
    };
  },
  computed: {},
  methods: {
    doNothing() {},
    toggleAudio() {
      if (!this.$refs.video) return;
      this.$refs.video.muted = !this.$refs.video.muted;
      this.isMuted = this.$refs.video.muted;
      localStorage.setItem('bye_audio_muted', (this.isMuted ? 'y' : 'n'));
    },
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
    previewImg(e, i) {
      this.$refs.imageViewer.open({
        e,
        i: i - 1,
        item: this.gallery[i - 1],
        items: this.gallery,
      });
    },
    docScrolled() {
      this.scrolled = (window.pageYOffset >= 30);
      this.fadeBlack = window.pageYOffset / 600;
      this.fadeWhite = (window.pageYOffset - 1400) / 400;
    },
    openVideo(video, name) {
      this.muteAudio();
      this.$refs.videoDialogLocal.open(video, name);
    },
    openWebtoon(i) {
      let uri = '';
      switch (i) {
        case 1:
          uri = 'https://www.webtoons.com/id/canvas/samodra/eps-20-cita-cita-volunteer/viewer?title_no=734808&episode_no=24';
          break;
        case 2:
          uri = 'https://www.webtoons.com/id/canvas/samodra/eps-19-reuni-mantan/viewer?title_no=734808&episode_no=23';
          break;
        case 3:
          uri = 'https://www.webtoons.com/id/canvas/samodra/eps-18-publish/viewer?title_no=734808&episode_no=22';
          break;
        case 4:
          uri = 'https://www.webtoons.com/id/canvas/samodra/eps-17-bala-bantuan/viewer?title_no=734808&episode_no=21';
          break;
        case 5:
          uri = 'https://www.webtoons.com/id/canvas/samodra/eps-16b-diancam/viewer?title_no=734808&episode_no=20';
          break;
        case 6:
          uri = 'https://www.webtoons.com/id/canvas/samodra/eps-16-diancam/viewer?title_no=734808&episode_no=19';
          break;
        case 7:
          uri = 'https://www.webtoons.com/id/canvas/samodra/eps-15-barcode-seafood-kw-1/viewer?title_no=734808&episode_no=18';
          break;
        case 8:
          uri = 'https://www.webtoons.com/id/canvas/samodra/eps-14b-berburu-memori-/viewer?title_no=734808&episode_no=17';
          break;
        default:
          break;
      }
      if (uri === '') return;
      window.open(uri, '_blank').focus();
    },
    muteAudio() {
      if (this.$refs.video) {
        this.$refs.video.muted = true;
        this.isMuted = this.$refs.video.muted;
        // localStorage.setItem('bye_audio_muted', 'y');
      }
    },
    logoClicked() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    openTrailer(item) {
      this.muteAudio();
      this.$refs.videoDialogSinopsis.open(item);
    },
    openTrailerComingSoon() {
      this.muteAudio();
      this.$refs.videoDialogComingSoon.open();
    },
    openIntro() {
      this.welcome.intro = true;
      document.getElementsByTagName('BODY')[0].classList.remove('stopscroll');
      setTimeout(() => {
        if (this.isMuted) this.$refs.video.muted = true;
        this.$refs.video.play();
      });
      setTimeout(() => {
        this.welcome.introFinished = true;
      }, 500);
      setTimeout(() => {
        this.welcome.video = true;
      }, 1800);
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  watch: {
    $route() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    document.getElementsByTagName('BODY')[0].classList.add('stopscroll');
    this.isMuted = localStorage.getItem('bye_audio_muted') === 'y';

    /**
     * Validate language
     *
     */
    if (!this.$route.params.lang) {
      let langCode = window.navigator.userLanguage || window.navigator.language;
      langCode = (langCode.indexOf('id') >= 0) ? 'id' : 'en';
      const countryCode = (langCode === 'id') ? 'id' : 'us';
      window.location.href = `/${langCode}-${countryCode}`;
      this.lang = langCode;
      this.langCode = `${langCode}-${countryCode}`;
    } else {
      this.langCode = this.$route.params.lang;
      [this.lang] = this.langCode.split('-');
    }

    /**
     * Get dialog
     *
     */
    this.$http.get(this.$config.uri('config/section/dialog')).then((r) => {
      const dialog = r.data.status === 200 ? r.data.data : null;
      if (!dialog || !dialog.displayDialog) return;
      let dialogExpiry;
      const dialogExpiryStr = localStorage.getItem('icel_dialog_expiry');
      if (dialogExpiryStr) {
        try {
          dialogExpiry = JSON.parse(dialogExpiryStr);
        } catch (err) {
          console.error(err); // eslint-disable-line
        }
      }
      if (dialogExpiry && dialogExpiry.id === dialog.dialogId
        && Math.floor(Date.now() / 1000) < parseInt(dialogExpiry.expiry, 10)) {
        return;
      }
      this.$refs.welcomeDialog.open(dialog);
      const d = new Date();
      if (dialog.dialogExpiry) d.setMinutes(d.getMinutes() + dialog.dialogExpiry);
      const dialogLocalData = {
        expiry: Math.floor(d.getTime() / 1000),
        id: dialog.dialogId,
      };
      localStorage.setItem('icel_dialog_expiry', JSON.stringify(dialogLocalData));
    });

    /**
     * Get main page
     *
     */
    this.$http.get(this.$config.uri('page/main')).then((r) => {
      const page = r.data.status === 200 ? r.data.data : null;
      const sectionData = [];
      // eslint-disable-next-line
      for (const item of page.page.sectionData) {
        item.modalOpen = false;
        if (item.id === 'home-slider') {
          this.pd.home = item;
        } else if (item.id === 'home-logo') {
          this.pd.homeLogo = item;
        } else if (item.id === 'org-logo') {
          this.pd.orgLogo = item;
        } else if (item.id === 'home-video') {
          this.pd.homeVideo = item;
        } else if (item.id === 'trailer') {
          this.pd.trailer = item;
        } else {
          sectionData.push(item);
        }
      }
      this.page = page;
      this.page.page.sectionData = sectionData;
      setTimeout(() => {
        this.loading = false;
        setTimeout(() => {
          this.welcome.open = true;
          setTimeout(() => {
            this.$refs.enterSite.focus();
          });
          setTimeout(() => {
            this.welcome.openFinished = true;
          }, 500);
        });
      }, 1400);
    });
  },
};
</script>

<style lang="scss">
.welcome-cnt{
  padding: 100vh 0 0;
  .section{
    position: relative;
    z-index: 95;
    &.modalOpen{
      z-index: 999;
    }
    .sectionHeader{
      .sectionTitle{
        font-family: 'Bebas Neue', sans-serif;
        font-size: 40px;
        text-align: center;
        margin: 0;
        line-height: 1.2;
      }
    }
    .sinopsis{
      max-width: 1024px;
      color: #FFCC00;
      margin: 0 auto;
      padding: 20px 40px 30px;
      background: -webkit-linear-gradient(#FF9100, #FFCC00, #FF9100);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      @media (max-width: 680px) {
        padding-left: 16px;
        padding-right: 16px;
      }
      .sectionHeader{
        padding: 0;
      }
      p.sectionDesc{
        // margin: 0 0 96px;
        margin: 0;
        font-size: 25px;
        font-weight: 500;
        text-align: center;
        line-height: 1.4;
        @media (max-width: 960px) {
          font-size: 24px;
        }
        @media (max-width: 680px) {
          font-size: 16px;
          // margin: 0 0 50px;
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
.page-loading{
  position: fixed;
  left: 0; top: 0; right: 0;
  z-index: 99;
  background-color: #fff;
  height: 100vh;
  background-image: url(../assets/loading-thin.svg);
  background-size: 180px auto;
  background-position: center;
  background-repeat: no-repeat;
  transition: all .3s ease;
  &.closed{
    opacity: 0;
    visibility: hidden;
  }
  &:before{
    content: "";
    position: absolute;
    left: 50%; top: 50%;
    transform: translate(-50%, -50%);
    width: 86px; height: 86px;
    background-image: url(../assets/bye-logo-no-shadow.png);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
}
.welcome-cnt{
  padding: 100vh 0 0;
  .welcome{
    position: fixed;
    left: 0; right: 0; top: 0;
    height: 100vh;
    .welcome-bg{
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      transform: scale(1.2);
      // background-image: url(../assets/bye-home-bg.jpg);
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      transition: 1.4s ease;
    }
    .welcome-overlay{
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      background-color: #000;
      opacity: 0;
      z-index: 3;
      transition: 1.2s ease;
    }
    .welcome-video{
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      z-index: 2;
      opacity: 0;
      transition: all 1.2s ease;
      video{
        width: 100%; height: 100%;
        object-fit: cover;
      }
    }
    .info-cnt{
      position: absolute;
      left: 50%; bottom: 60px;
      transform: translateX(-50%) scale(0.9);
      z-index: 5;
      text-align: center;
      transition: all .4s ease-out;
      opacity: 0;
      @media (max-width: 1480px) {
        bottom: 30px;
      }
      @media (max-width: 1200px) {
        bottom: 80px;
      }
      .btn{
        margin: 0 10px 40px;
        border-radius: 100px;
        width: auto;
        padding: 12px 60px 10px;
        font-size: 26px;
        color: #444;
        line-height: 1.4;
        background: linear-gradient(180deg, #FF8B66 0%, #FC0 52.08%, #FF9100 100%);
        @media (max-width: 1480px) {
          font-size: 24px;
          padding: 10px 40px 8px;
        }
        &:hover{
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
        }
        &:focus{
          outline: #ffd1c0 2px solid !important;
        }
      }
      .org-logos{
        display: flex;
        .logo-item{
          color: #fff;
          margin: 0 16px;
          h4{
            font-size: 16px;
            margin: 0 0 10px;
            white-space: nowrap;
            @media (max-width: 1480px) {
              font-size: 14px;
            }
            @media (max-width: 680px) {
              font-size: 12px;
            }
          }
          img{
            height: 76px;
            @media (max-width: 1480px) {
              height: 68px;
            }
            @media (max-width: 680px) {
              height: 46px;
            }
          }
        }
      }
    }
  }
  .welcome-overlay-2{
    position: fixed;
    left: 0; right: 0; top: 0;
    height: 100vh;
    background: linear-gradient(180deg, rgba(0,0,0,.8) 0%, transparent 50%, rgba(0,0,0,.8) 90%);
    opacity: 0;
    z-index: 4;
    transition: 1.2s ease;
    display: none;
  }
  .welcome-overlay-3{
    position: fixed;
    left: 0; right: 0; top: 0;
    height: 100vh;
    background-color: #000;
    opacity: 0;
    z-index: 4;
    display: none;
    &.overlay-3a{
      background-color: #FFCC00;
      background-color: #fff;
    }
  }
  .sinopsis{
    max-width: 1024px;
    color: #FFCC00;
    font-size: 26px;
    margin: 0 auto;
    padding: 20px 40px 30px;
    font-weight: 500;
    background: -webkit-linear-gradient(#FF9100, #FFCC00, #FF9100);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    @media (max-width: 960px) {
      font-size: 24px;
    }
    @media (max-width: 680px) {
      font-size: 16px;
      padding-left: 16px;
      padding-right: 16px;
    }
    p{
      margin: 0 0 96px;
      text-align: center;
      line-height: 1.4;
      @media (max-width: 680px) {
        margin: 0 0 50px;
      }
    }
  }
  .section{
    position: relative;
    z-index: 95;
  }
  .logo{
    position: fixed;
    left: 50%; top: 50%;
    transform: translate(-50%, -50%) scale(.9);
    width: 400px; height: 400px;
    // background-image: url(../assets/bye-logo-no-shadow.png);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    margin-top: -120px;
    z-index: 99;
    opacity: 0;
    transition: all .4s ease;
    cursor: pointer;
    @media (max-width: 1480px) {
      width: 300px; height: 300px;
    }
    @media (max-width: 680px) {
      width: 280px; height: 280px;
    }
  }
  .welcome-action{
    position: fixed;
    left: 0; right: 0; bottom: 40px;
    z-index: 99;
    color: #fff;
    text-align: center;
    transition: all .7s ease;
    opacity: 0;
    visibility: hidden;
    @media (max-width: 640px) {
      bottom: 20px;
    }
    &.hidden{
      opacity: 0 !important;
      visibility: hidden !important;
    }
    .trailer-cnt{
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      margin: 0 0 10px;
      @media (max-width: 640px) {
        padding: 0 20px;
        justify-content: space-around;
      }
      &.trailer-item-2{
        &:before{
          content: "";
          position: absolute;
          left: 50%; top: 4px; bottom: 4px;
          width: 1px;
          background-color: #fff;
        }
      }
      .trailer-item{
        font-size: 17px;
        margin: 0 34px;
        position: relative;
        cursor: pointer;
        padding-left: 30px;
        text-transform: uppercase;
        @media (max-width: 640px) {
          margin: 0;
          padding: 30px 0 0;
          text-align: center;
          max-width: 120px;
          line-height: 1.1;
        }
        &:after{
          content: "";
          position: absolute;
          left: 0; top: 2px;
          width: 18px; height: 18px;
          border-radius: 50%;
          border: #fff 1px solid;
          background-image: url(../assets/play-icon-white.png);
          background-size: 8px auto;
          background-position: 6px 50%;
          background-repeat: no-repeat;
          @media (max-width: 640px) {
            top: 0; left: 50%;
            margin-left: -9px;
          }
        }
        &:before{
          content: "";
          position: absolute;
          top: 50%; left: 50%;
          transform: translate(-50%, -50%);
          width: 0; height: 100%;
          background-image: url(../assets/hover-bg-orange.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
          transition: all .2s ease;
          opacity: 0;
          @media (max-width: 640px) {
            display: none;
          }
        }
        &:hover{
          &:before{
            width: 120%;
            opacity: 1;
          }
        }
        span{
          position: relative;
          z-index: 3;
        }
      }
    }
    .scroll-info{
      padding-top: 40px;
      font-size: 14px;
      position: relative;
      @keyframes bounce {
        70% { transform:translateY(0%); }
        80% { transform:translateY(-15%); }
        90% { transform:translateY(0%); }
        95% { transform:translateY(-7%); }
        97% { transform:translateY(0%); }
        99% { transform:translateY(-3%); }
        100% { transform:translateY(0); }
      }
      &:before{
        content: "";
        position: absolute;
        width: 30px; height: 30px;
        background-image: url(../assets/mouse-white.png);
        background-size: 30px auto;
        background-position: center;
        background-repeat: no-repeat;
        left: 50%; top: 0;
        margin-left: -15px;
        animation: bounce 2s ease infinite;
      }
    }
  }
  &.open{
    .welcome{
      .welcome-bg{
        transform: scale(1);
      }
      .welcome-overlay{
        opacity: .4;
      }
      .info-cnt{
        opacity: 1;
        transform: translateX(-50%);
      }
    }
    .logo{
      transform: translate(-50%, -50%);
      opacity: 1;
    }
  }
  &.openFinished{
    .logo{
      transition: all .9s ease-out;
    }
    .info-cnt{
      transition: all .7s ease-out;
    }
  }
  &.intro{
    .logo{
      width: 74px; height: 74px;
      top: 10px;
      margin: 0;
      transform: translateX(-50%);
      @media (max-width: 980px) {
        transform: none;
        left: 40px;
      }
      @media (max-width: 840px) {
        left: 16px;
        width: 56px; height: 56px; top: 8px;
      }
    }
    .welcome{
      .info-cnt{
        opacity: 0;
      }
      .welcome-overlay{
        opacity: 1;
      }
    }
    .welcome-action{
      visibility: visible;
      opacity: 1;
    }
    .welcome-overlay-2,
    .welcome-overlay-3{
      display: block;
    }
  }
  &.video{
    .welcome-overlay-2{
      opacity: 1;
    }
    .welcome{
      .welcome-overlay{
        opacity: 0;
      }
      .welcome-video{
        opacity: 1;
      }
    }
  }
}


.gallery{
  padding: 40px 0 80px;
  @media (max-width: 680px) {
    padding: 30px 0 60px;
  }
  .marusCnt{
    overflow: hidden;
    @media (max-width: 1080px) {
      padding: 20px 0;
    }
    @media (max-width: 680px) {
      padding: 10px 0;
    }
    .marus{
      background-size: auto 100%;
      background-repeat: no-repeat;
      margin: 40px 0;
      display: flex;
      width: 144vw;
      @media (max-width: 1080px) {
        margin: 20px 0;
      }
      @media (max-width: 960px) {
        width: 216vw;
      }
      @media (max-width: 680px) {
        margin: 10px 0;
        width: 288vw;
      }
      .maru{
        background-color: #eee;
        height: calc(16vw - 40px); width: calc(24vw - 40px);
        margin-right: 40px;
        background-position: center;
        background-size: cover;
        transition: all .3s ease;
        cursor: pointer;
        position: relative;
        border-radius: 7px;
        &.lg1a{
          background-image: url(../assets/12foto/1.jpg);
        }
        &.lg2a{
          background-image: url(../assets/12foto/2.jpg);
        }
        &.lg3a{
          background-image: url(../assets/12foto/3.jpg);
        }
        &.lg4a{
          background-image: url(../assets/12foto/4.jpg);
        }
        &.lg5a{
          background-image: url(../assets/12foto/5.jpg);
        }
        &.lg6a{
          background-image: url(../assets/12foto/6.jpg);
        }
        &.lg1b{
          background-image: url(../assets/12foto/7.jpg);
        }
        &.lg2b{
          background-image: url(../assets/12foto/8.jpg);
        }
        &.lg3b{
          background-image: url(../assets/12foto/9.jpg);
        }
        &.lg4b{
          background-image: url(../assets/12foto/10.jpg);
        }
        &.lg5b{
          background-image: url(../assets/12foto/11.jpg);
        }
        &.lg6b{
          background-image: url(../assets/12foto/12.jpg);
        }
        &.lg1c{
          background-image: url(../assets/12foto/13.jpg);
        }
        &.lg2c{
          background-image: url(../assets/12foto/14.jpg);
        }
        &.lg3c{
          background-image: url(../assets/12foto/15.jpg);
        }
        &.lg4c{
          background-image: url(../assets/12foto/16.jpg);
        }
        &.lg5c{
          background-image: url(../assets/12foto/17.jpg);
        }
        &.lg6c{
          background-image: url(../assets/12foto/18.jpg);
        }
        @media (max-width: 1080px) {
          height: calc(16vw - 20px); width: calc(24vw - 20px);
          margin-right: 20px;
        }
        @media (max-width: 960px) {
          height: calc(22vw - 20px); width: calc(36vw - 20px);
          margin-right: 20px;
        }
        @media (max-width: 680px) {
          height: calc(32vw - 10px); width: calc(48vw - 10px);
          margin-right: 10px;
          &.lg1a{
            background-image: url(../assets/12foto/mobile/1.jpg);
          }
          &.lg2a{
            background-image: url(../assets/12foto/mobile/2.jpg);
          }
          &.lg3a{
            background-image: url(../assets/12foto/mobile/3.jpg);
          }
          &.lg4a{
            background-image: url(../assets/12foto/mobile/4.jpg);
          }
          &.lg5a{
            background-image: url(../assets/12foto/mobile/5.jpg);
          }
          &.lg6a{
            background-image: url(../assets/12foto/mobile/6.jpg);
          }
          &.lg1b{
            background-image: url(../assets/12foto/mobile/7.jpg);
          }
          &.lg2b{
            background-image: url(../assets/12foto/mobile/8.jpg);
          }
          &.lg3b{
            background-image: url(../assets/12foto/mobile/9.jpg);
          }
          &.lg4b{
            background-image: url(../assets/12foto/mobile/10.jpg);
          }
          &.lg5b{
            background-image: url(../assets/12foto/mobile/11.jpg);
          }
          &.lg6b{
            background-image: url(../assets/12foto/mobile/12.jpg);
          }
          &.lg1c{
            background-image: url(../assets/12foto/mobile/13.jpg);
          }
          &.lg2c{
            background-image: url(../assets/12foto/mobile/14.jpg);
          }
          &.lg3c{
            background-image: url(../assets/12foto/mobile/15.jpg);
          }
          &.lg4c{
            background-image: url(../assets/12foto/mobile/16.jpg);
          }
          &.lg5c{
            background-image: url(../assets/12foto/mobile/17.jpg);
          }
          &.lg6c{
            background-image: url(../assets/12foto/mobile/18.jpg);
          }
        }
        &:hover{
          transform: scale(1.12);
          @media (max-width: 1080px) {
            transform: scale(1.08);
          }
        }
      }
      &.marus1{
      }
      &.marus2{
        margin-left: calc(-44vw + 40px);
        @media (max-width: 680px) {
          transform: translateX(-200px);
        }
      }
    }
    &.loading{
      .marus{
        .maru{
          cursor: default;
          transform: none;
        }
      }
    }
  }
}


.section-title{
  font-family: 'Bebas Neue', sans-serif;
  font-size: 40px;
  text-align: center;
  margin: 0;
  line-height: 1.2;
  @media (max-width: 680px) {
    font-size: 36px;
    margin: 0 20px;
  }
}
.section-subtitle{
  margin: 0 auto;
  max-width: 860px;
  font-size: 18px;
  text-align: center;
  @media (max-width: 640px) {
    font-size: 15px;
    line-height: 1.3;
  }
}

// .watch{
//   padding: 40px 0 100px;
//   @media (max-width: 1280px) {
//     padding-bottom: 40px;
//   }
//   @media (max-width: 940px) {
//     padding-bottom: 60px;
//   }
//   @media (max-width: 640px) {
//     padding-bottom: 20px;
//   }
//   .watch-cnt{
//     max-width: 1260px;
//     margin: 0 auto;
//     display: flex;
//     padding: 60px 0 40px;
//     @media (max-width: 940px) {
//       display: block;
//       padding-bottom: 10px;
//     }
//     @media (max-width: 680px) {
//       margin: 0 20px;
//     }
//     .watch-item{
//       text-align: center;
//       width: 50%;
//       box-sizing: border-box;
//       padding: 0 80px;
//       @media (max-width: 940px) {
//         width: auto;
//         margin: 0 0 100px;
//       }
//       @media (max-width: 680px) {
//         padding: 0;
//       }
//       &:last-child{
//         margin: 0;
//       }
//       p{
//         font-size: 20px;
//         margin: 0 0 20px;
//         @media (max-width: 680px) {
//           line-height: 1.3;
//           font-size: 18px;
//         }
//         b{
//           color: #E9134F;
//         }
//       }
//       .watch-img{
//         margin: 0 0 40px;
//         img{
//           height: 340px;
//           margin: 0 auto;
//           display: block;
//           @media (max-width: 680px) {
//             height: auto;
//             width: 90%;
//           }
//         }
//       }
//       .btn{
//         border-radius: 50px;
//         display: inline-block;
//         width: auto;
//       }
//     }
//   }
// }
// .work{
//   background-color: #486CB1;
//   color: #fff;
//   margin: 200px 0;
//   @media (max-width: 940px) {
//     margin: 120px 0;
//   }
//   @media (max-width: 740px) {
//     padding: 40px 0 0;
//   }
//   &:before{
//     content: "";
//     position: absolute;
//     height: 200px; top: -200px;
//     left: 0; right: 0;
//     background-image: url(../assets/blue-divider-top.png);
//     background-size: 100% auto;
//     background-position: bottom center;
//     background-repeat: no-repeat;
//   }
//   &:after{
//     content: "";
//     position: absolute;
//     height: 200px; bottom: -200px;
//     left: 0; right: 0;
//     background-image: url(../assets/blue-divider-bottom.png);
//     background-size: 100% auto;
//     background-position: top center;
//     background-repeat: no-repeat;
//   }
//   .work-cnt{
//     display: flex;
//     max-width: 1260px;
//     margin: 0 auto;
//     padding: 40px 0;
//     @media (max-width: 1240px) {
//       max-width: 1180px;
//     }
//     @media (max-width: 940px) {
//       display: block;
//     }
//     .work-item{
//       text-align: center;
//       width: 50%;
//       box-sizing: border-box;
//       padding: 0 60px;
//       @media (max-width: 940px) {
//         width: auto;
//         margin: 0 0 80px;
//       }
//       @media (max-width: 640px) {
//         padding: 0 24px;
//         margin: 0 0 60px;
//       }
//       &:last-child{
//         @media (max-width: 940px) {
//           margin: 0;
//         }
//       }
//       h4{
//         font-size: 20px;
//         margin: 0;
//         font-weight: 500;
//       }
//       .work-video{
//         height: 300px;
//         border-radius: 7px;
//         background-size: cover;
//         background-position: center;
//         background-repeat: no-repeat;
//         margin: 0 0 20px;
//         transition: all .3s ease;
//         position: relative;
//         cursor: pointer;
//         @media (max-width: 1240px) {
//           height: 260px;
//         }
//         @media (max-width: 940px) {
//           height: 46vw;
//         }
//         &:before{
//           content: "";
//           position: absolute;
//           left: 50%; top: 50%;
//           width: 54px; height: 54px;
//           margin: -27px 0 0 -27px;
//           border: #fff 2px solid;
//           border-radius: 50%;
//           background-image: url(../assets/play-white.png);
//           background-size: 26px auto;
//           background-position: 15px 50%;
//           background-repeat: no-repeat;
//           opacity: .3;
//           transition: all .3s ease;
//         }
//         &:hover{
//           box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
//           &:before{
//             opacity: .7;
//           }
//         }
//         &.video-1{
//           background-image: url(../assets/stop-motion.jpg);
//         }
//         &.video-2{
//           background-image: url(../assets/voice-from-the-sea.jpg);
//         }
//       }
//     }
//   }
// }
// .webtoon{
//   max-width: 1400px;
//   margin: 0 auto;
//   padding: 60px 0;
//   @media (max-width: 1480px) {
//     max-width: 1200px;
//   }
//   @media (max-width: 1260px) {
//     margin: 0 40px;
//     max-width: none;
//   }
//   @media (max-width: 640px) {
//     margin: 0 16px;
//     padding: 0 0 60px;
//   }
//   .webtoon-cnt{
//     display: flex;
//     flex-wrap: wrap;
//     padding: 30px 0 40px;
//     margin: 0 -16px;
//     @media (max-width: 640px) {
//       padding: 10px 0 30px;
//       margin: 0 -8px;
//     }
//     .webtoon-item{
//       width: 25%;
//       padding: 16px;
//       @media (max-width: 960px) {
//         width: 33.333333%;
//       }
//       @media (max-width: 840px) {
//         width: 50%;
//       }
//       @media (max-width: 640px) {
//         padding: 8px;
//       }
//       .webtoon-item-in{
//         background-color: #eee;
//         border-radius: 7px;
//         height: 300px;
//         background-size: cover;
//         background-position: center;
//         background-repeat: no-repeat;
//         transition: all .3s ease;
//         cursor: pointer;
//         @media (max-width: 1480px) {
//           height: 260px;
//         }
//         @media (max-width: 1260px) {
//           height: 20vw;
//         }
//         @media (max-width: 960px) {
//           height: 24vw;
//         }
//         @media (max-width: 840px) {
//           height: 38vw;
//         }
//         &:hover{
//           transform: scale(1.06);
//         }
//       }
//       &.webtoon-item-1{
//         .webtoon-item-in{
//           background-image: url(../assets/webtoon/20.png);
//         }
//       }
//       &.webtoon-item-2{
//         .webtoon-item-in{
//           background-image: url(../assets/webtoon/19.jpg);
//         }
//       }
//       &.webtoon-item-3{
//         .webtoon-item-in{
//           background-image: url(../assets/webtoon/18.png);
//         }
//       }
//       &.webtoon-item-4{
//         .webtoon-item-in{
//           background-image: url(../assets/webtoon/17-1.png);
//         }
//       }
//       &.webtoon-item-5{
//         .webtoon-item-in{
//           background-image: url(../assets/webtoon/16b.png);
//         }
//       }
//       &.webtoon-item-6{
//         .webtoon-item-in{
//           background-image: url(../assets/webtoon/16.png);
//         }
//       }
//       &.webtoon-item-7{
//         .webtoon-item-in{
//           background-image: url(../assets/webtoon/15.jpg);
//         }
//       }
//       &.webtoon-item-8{
//         .webtoon-item-in{
//           background-image: url(../assets/webtoon/14b.jpg);
//         }
//       }
//     }
//   }
//   .btn-cnt{
//     text-align: center;
//     .btn.primary{
//       border-radius: 50px;
//       width: auto;
//       display: inline-block;
//     }
//   }
// }

// footer{
//   background-color: #486CB1;
//   position: relative;
//   z-index: 95;
//   padding: 0 0 120px;
//   margin-top: 200px;
//   &:before{
//     content: "";
//     position: absolute;
//     height: 200px; top: -200px;
//     left: 0; right: 0;
//     background-image: url(../assets/blue-divider-top.png);
//     background-size: 100% auto;
//     background-position: bottom center;
//     background-repeat: no-repeat;
//   }
//   .footer-cnt{
//     display: flex;
//     max-width: 1300px;
//     margin: 0 auto;
//     .footer-logo{
//       width: 200px;
//       img{
//         width: 140px;
//       }
//     }
//     .footer-info{
//       width: calc(100% - 880px);
//       h4{
//         font-weight: 600;
//         font-size: 20px;
//         margin: 0 0 8px;
//       }
//       p{
//         margin: 0 0 8px;
//         font-size: 16px;
//       }
//       .copyright{
//         font-size: 15px;
//       }
//     }
//     .footer-org-logo{
//       width: 480px;
//       display: flex;
//       justify-content: center;
//       .org-logo{
//         padding: 0 20px;
//         h4{
//           margin: 0 0 6px;
//           font-size: 14px;
//           text-align: center;
//         }
//         img{
//           height: 86px;
//         }
//       }
//     }
//     .footer-socmed{
//       width: 200px;
//       display: flex;
//       .socmed-item{
//         display: block;
//         width: 30px; height: 30px;
//         margin: 0 6px;
//         background-color: #000;
//       }
//     }
//   }
// }
</style>
